import React from 'react'
import { ModalComponent } from '../../../components/Modal.components';
import { Boxed } from '../../../components/Boxed.components';
import { Text } from '../../../components/Text.components';
import { Button } from '../../../components/Button.components';
import { PageTitle } from '../../../components/style';

export const SwitchToCompanyModal = (props) => {
  const { switchCompanyModal, singleCompanyData } = props;
  // Dispatch props

  const { closeModal, switchToCompany } = props;

  // console.log(singleCompanyData);

  return (
    <ModalComponent
      show={switchCompanyModal}
      onHide={closeModal}
      title={<PageTitle margin="5px 0">Switch Organizations</PageTitle>}
      footer={
        <Boxed display="flex" width="100%">
          <Button clear onClick={closeModal}>
            Cancel
          </Button>
          <Button
            margin="0 0 0 auto"
            onClick={() => {
              switchToCompany(singleCompanyData)
              // window.location.reload()
            }}
          >
            Switch
          </Button>
        </Boxed>
      }
    >
      <Text>Please confirm that you want to switch to this organisation.</Text>

  
    </ModalComponent>
  );
}

